import React from 'react';
import styled from 'styled-components';
import { MusicalNoteIcon } from '@heroicons/react/24/outline';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
  cursor: pointer;
`;

const IconContainer = styled.div`
  width: ${props => props.size === 'large' ? '40px' : '32px'};
  height: ${props => props.size === 'large' ? '40px' : '32px'};
  background: ${props => props.theme.colors.gradient};
  border-radius: ${props => props.theme.borderRadius.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: ${props => props.size === 'large' ? '20px' : '18px'};
    height: ${props => props.size === 'large' ? '20px' : '18px'};
    color: white;
  }
`;

const LogoTextStyled = styled.h1`
  font-family: 'Permanent Marker', cursive;
  font-size: ${props => props.size === 'large' ? props.theme.typography.h2.fontSize : props.theme.typography.h3.fontSize};
  font-weight: ${props => props.theme.typography.h2.fontWeight};
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;

  .scene, .feed {
    background: ${props => props.theme.colors.gradient};
    background-size: 100%;
    background-repeat: no-repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    width: fit-content;
    min-width: 0;
    white-space: nowrap;
  }

  .scene {
    transform: rotate(-25deg);
    transform-origin: left center;
    margin-top: 10px;
  }

  .feed {
    margin-left: -20px;
    margin-top: 10px;
  }
`;


const Logo = ({ size = 'medium' }) => {
  return (
    <LogoContainer>
      <IconContainer size={size}>
        <MusicalNoteIcon />
      </IconContainer>
      <LogoTextStyled size={size}>
        <span className="scene">SCENE</span>
        <span className="feed">FEED</span>
      </LogoTextStyled>
    </LogoContainer>
  );
};

export default Logo; 